import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=6165537a&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"
import style0 from "./Games.vue?vue&type=style&index=0&id=6165537a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165537a",
  null
  
)

export default component.exports